import React from 'react';
import { View, Modal } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import SohoFrameworkTestKeys from '../../../Utils/SohoFrameworkTestKeys';

import styles from './ResultModal.Styles';

function ResultModal({
  isVisible,
  title,
  description,
  subtitle,
  extraText,
  primaryBtnTitle,
  secondaryBtnTitle,
  onPrimaryBtnPress,
  onSecondaryBtnPress,
  renderBeforeTitle,
  withSecondaryButton,
  descriptionPlaceHolders,
  subtitlePlaceHolders,
  ...props
}) {
  const theme = useTheme();

  return (
    <Modal visible={isVisible === true}>
      <View style={styles.containerStyle(theme)}>
        <View style={styles.contentStyle}>
          {_isFunction(renderBeforeTitle) ? renderBeforeTitle() : null}

          <VFText
            i18nKey={title}
            style={styles.titleStyle(theme)}
            testKey={SohoFrameworkTestKeys.ResultModalSuccessfulTitle}
          />

          {description ? (
            <VFText
              i18nKey={description}
              placeHolders={descriptionPlaceHolders}
              type="primary"
              style={styles.descriptionStyle}
              testKey={SohoFrameworkTestKeys.ResultModalSuccessfulDescription}
            />
          ) : null}

          {subtitle ? (
            <VFText
              i18nKey={subtitle}
              placeHolders={subtitlePlaceHolders}
              type="primary"
              style={styles.subTitleStyle}
              testKey={SohoFrameworkTestKeys.ResultModalSuccessfulSubTitle}
            />
          ) : null}

          {extraText ? (
            <VFText
              i18nKey={extraText}
              placeHolders={subtitlePlaceHolders}
              type="primary"
              style={styles.subTitleStyle}
            />
          ) : null}
        </View>

        <View>
          <VFButton
            type="primary"
            title={primaryBtnTitle}
            onPress={onPrimaryBtnPress}
            style={[styles.buttonStyle, withSecondaryButton && styles.primaryButtonStyle]}
            textAccessibilityLabel={SohoFrameworkTestKeys.ResultModalSuccessfulPrimaryBtn}
          />

          {withSecondaryButton && (
            <VFButton
              type="secondary"
              title={secondaryBtnTitle}
              onPress={onSecondaryBtnPress}
              style={styles.buttonStyle}
              textAccessibilityLabel={SohoFrameworkTestKeys.ResultModalSuccessfulSecondaryButton}
            />
          )}
        </View>
      </View>
    </Modal>
  );
}
ResultModal.defaultProps = {
  withSecondaryButton: true,
};
ResultModal.propTypes = {
  isVisible: PropTypes.bool,
  withSecondaryButton: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  extraText: PropTypes.string,
  descriptionPlaceHolders: PropTypes.array,
  subtitlePlaceHolders: PropTypes.array,
  subtitle: PropTypes.string,
  primaryBtnTitle: PropTypes.string,
  secondaryBtnTitle: PropTypes.string,
  onPrimaryBtnPress: PropTypes.func,
  onSecondaryBtnPress: PropTypes.func,
  renderBeforeTitle: PropTypes.func,
};

export default ResultModal;
